import { render } from "./FlippedTable.vue?vue&type=template&id=2e9c0bcc&ts=true"
import script from "./FlippedTable.vue?vue&type=script&lang=ts"
export * from "./FlippedTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__